import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { FIREBASE_CONFIG } from "./connectionHelpers";
const firebaseConfig = {
  apiKey: FIREBASE_CONFIG.apiKey,
  authDomain: FIREBASE_CONFIG.projectId+".firebaseapp.com",
  projectId: FIREBASE_CONFIG.projectId,
  storageBucket: FIREBASE_CONFIG.projectId+".appspot.com",
  messagingSenderId: FIREBASE_CONFIG.messagingSenderId,
  appId: FIREBASE_CONFIG.appId,
  measurementId: FIREBASE_CONFIG.measurementId
};
export const app = initializeApp(firebaseConfig);
export const messaging=getMessaging(app);
export const analytics = getAnalytics(app);